import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import { PaymentLottie } from '../../../Payment';

import styles from './Loading.styles';

const Loading = ({
  loadingContainerStyle,
  loadingIconStyle,
  autoPlay,
  loop,
  loadingMessage,
  loadingMessageTextStyle,
  modalHeight,
  type,
  theme,
  loadingLottieViewStyle,
}) => (
  <View style={[styles.loadingContainer(modalHeight), loadingContainerStyle]}>
    <PaymentLottie
      isPaymentRequest
      type={type}
      style={[styles.loadingIcon, loadingIconStyle]}
      autoPlay={autoPlay}
      loop={loop}
      lottieViewStyle={loadingLottieViewStyle}
    />
    <VFText
      i18nKey={loadingMessage}
      style={[styles.loadingMessage(theme), loadingMessageTextStyle]}
    />
  </View>
);

Loading.defaultProps = {
  autoPlay: true,
  loop: true,
};

Loading.propTypes = {
  modalHeight: PropTypes.number,
  loadingContainerStyle: ViewPropTypes.style,
  loadingIconStyle: ViewPropTypes.style,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  loadingMessage: PropTypes.string,
  loadingMessageTextStyle: TextPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  type: PropTypes.oneOf(Object.values(LottieTypes)),
  loadingLottieViewStyle: ViewPropTypes.style,
};

export default withTheme(Loading);
